import { TranslationKey } from "../../../shared/i18n/i18n";
import { AppPopup } from "../../../shared/components/AppPopup";

type TermsOfUseAcceptancePopupProps = {
  dismissible: boolean;
  isOpen: boolean;
  isSubmitting: boolean;
  onAccept: () => void;
  onClose: () => void;
  onOpenTermsOfUse: () => void;
  t: (key: TranslationKey) => string;
};

export const TermsOfUseAcceptancePopup = ({
  dismissible,
  isOpen,
  isSubmitting,
  onAccept,
  onClose,
  onOpenTermsOfUse,
  t,
}: TermsOfUseAcceptancePopupProps) => {
  return (
    <AppPopup
      actions={(
        <>
          {dismissible ? (
            <button
              className="admin-popup-action"
              onClick={onClose}
              type="button"
            >
              {t("admin.button.close")}
            </button>
          ) : null}
          <button
            className="admin-popup-action primary"
            onClick={onAccept}
            type="button"
          >
            {isSubmitting ? t("admin.button.acceptingTerms") : t("admin.button.acceptTerms")}
          </button>
        </>
      )}
      dismissible={dismissible}
      isOpen={isOpen}
      onClose={onClose}
      title={t("admin.terms.popupTitle")}
    >
      <p className="admin-terms-popup-copy">
        {t("admin.terms.popupPrefix")}{" "}
        <button
          className="inline-link-anchor"
          onClick={onOpenTermsOfUse}
          type="button"
        >
          {t("admin.terms.linkLabel")}
        </button>
        . {t("admin.terms.popupSuffix")}
      </p>
    </AppPopup>
  );
};
